<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_head">
          <div class="content_head_ico">
            <img src="@/assets/images/worktable/titleguoducolor.png" alt="" />
          </div>
          <div class="content_head_title">质检报告</div>
          <div class="content_head_button">
            <div class="content_head_seek content_searchlistbox">
              <lk-button img="searchlist.png" @click="searchlistshow = !searchlistshow"></lk-button>
              <img v-show="searchlistshow" class="content_searchlist" src="@/assets/images/xiala.png" alt="">
            </div>
            <div class="content_head_seek">
              <lk-button img="add.png" @click="buttonSwitch('', 0)" v-if="permissionAddIs">新增</lk-button>
            </div>
            <div class="content_head_seek">
              <lk-button img="export.png" type="lk_button_blue" @click="exportExcel" v-loading="exportloading" :element-loading-background="config.loading.background">导出</lk-button>
            </div>
          </div>
        </div>
        <div class="searchlistbox" v-show="searchlistshow">
          <div class="content_head_seek">
            <el-input placeholder="请输入编号" v-model="number" class="input-with-select">
            </el-input>
          </div>
          <div class="content_head_seek">
            <el-select v-model="type" filterable placeholder="质检类型">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="content_head_seek">
            <el-select v-model="grainBelong" filterable placeholder="粮权所属">
              <el-option v-for="item in grainBelongList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="content_head_seek">
            <el-cascader v-model="grainKind" :options="grainKindList" placeholder="粮食品种" clearable
              filterable></el-cascader>
          </div>
          <div class="content_head_seek">
            <div class="block">
              <el-date-picker v-model="timepicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="content_head_seek">
            <lk-button @click="getDataList(1)">查询</lk-button>
          </div>
          <div class="content_head_seek">
            <lk-button type="lk_button_blue" @click="searchReset">重置</lk-button>
          </div>
        </div>
        <div class="Notice_list">
          <el-table :data="Notice" style="width: 100%">
            <el-table-column prop="number" label="编号" width="180" align="center"/>
            <el-table-column prop="barnVName" label="仓房号" align="center"/>
            <el-table-column prop="grainNature" label="粮食性质" align="center"/>
            <el-table-column prop="grainBelong" label="粮权所属" align="center"/>
            <el-table-column prop="foVariety" label="粮食品种" align="center"/>
            <el-table-column prop="foGrade" label="粮食等级" align="center"/>
            <el-table-column prop="typeCn" label="质检类型" align="center"/>
            <el-table-column prop="checkTime" label="检验时间" align="center"/>
            <el-table-column prop="inspector" label="检验单位" align="center"/>
            <!--            <el-table-column prop="reviewer" label="审核人" align="center">-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                label="检验信息"-->
            <!--                align="center">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-button type="text" size="small" @click="alertShow('检验信息',scope.row,'880px')">查看</el-button>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="scope">
                <el-button v-if="permissionFindIs" type="text" size="small"
                  @click="buttonSwitch(scope.row.number, 1,scope.row.id)">详情</el-button>
                <el-button type="text" size="small" @click="buttonSwitch(scope.row.number,2,scope.row.id)">编辑</el-button>
                <el-button v-if="permissionDelIs" type="text" size="small" @click="deleteButton(scope.row.id)"
                  style="color: red">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <div class="block">
            <el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
              :current-page="currentPage" :page-size="pageSize" :page-sizes="config.pagesizes"
              layout="total, prev, pager, next, jumper,sizes" :total="totalPage">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { httpToken } from "@/utils/http";
import qs from "qs";
import { export2Excel, getdatadirid } from "@/utils/util";
import { getGrainKindDictionary } from "@/utils/warehouseInOut";
import { getjudgePermission } from '@/utils/server/permission'
export default {
  name: "Report",
  data() {
    return {
      permissionAddIs: false,//新增权限
      permissionDelIs: false,//删除权限
      permissionFindIs: false,//详情权限
      Notice: [],
      number: '',
      type: '',
      grainBelong: '',
      grainKind: [],
      typeList: [],
      grainBelongList: [],
      grainKindList: getGrainKindDictionary(),
      currentPage: 1,
      pageSize: 10,
      totalPage: 0,
      timepicker: "",
      columns: [
        { title: "编号", key: "number" },
        { title: "仓房号", key: "warehouseNumberCn" },
        { title: "粮食性质", key: "grainNature" },
        { title: "粮权所属", key: "grainBelong" },
        { title: "粮食品种", key: "foVariety" },
        { title: "粮食等级", key: "foGrade" },
        { title: "质检类型", key: "typeCn" },
        { title: "质检时间", key: "checkTime" },
        { title: "检验人", key: "inspector" },
        // {title: "审核人", key: "reviewer"},
      ],
      searchlistshow: false,
      exportloading:false,
      exportData: [],//所有导出数据
    };
  },
  mounted() {
    getjudgePermission('1113').then(res => {
      this.permissionAddIs = res
    })
    getjudgePermission('1114').then(res => {
      this.permissionDelIs = res
    })
    getjudgePermission('1116').then(res => {
      this.permissionFindIs = res
    })
    this.typeList = getdatadirid('Testtype', 1, true)
    this.getGrainBelongOptions()
    this.getDataList(1)
  },
  methods: {
    ...mapMutations('Quality', ['setQualityState', 'setQualityId','setQuaid']),
    getparamData(){
      let paramData = [{ column: 'unit', type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId },{column:'check_time', type: 'orderByDesc'}]
      if (this.number) {
        paramData.push({ column: 'number', type: 'like', value: this.number })
      }
      if (this.type) {
        paramData.push({ column: 'type', type: 'eq', value: this.type })
      }
      if (this.grainBelong) {
        paramData.push({ column: 'grain_belong', type: 'eq', value: this.grainBelong })
      }
      if (this.grainKind.length !== 0) {
        paramData.push({ column: 'fo_variety', type: 'eq', value: this.grainKind[1] })
      }
      if (this.timepicker) {
        paramData.push({ column: "create_date", type: "ge", value: this.timepicker[0] });
        paramData.push({ column: "create_date", type: "le", value: this.timepicker[1] + " 23:59:59" });
      }
      return paramData
    },
    // 获取基本数据
    getDataList(page, status) {
      this.currentPage = page
      httpToken({
        method: 'post',
        url: '/granary-quality-report/list',
        data: qs.stringify({
          page: page,
          paramData: JSON.stringify(this.getparamData()),
          rows: this.pageSize,
        })
      }).then(res => {
        // console.log(res)
        this.Notice = []
        let Data = res.data.data
        if (status === 'delete' && Data.pages < this.currentPage && Data.pages !== 0) {
          this.currentPage = Data.pages
          this.getDataList(this.currentPage)
          return
        }
        this.Notice = res.data.data.records
        this.totalPage = res.data.data.total
      })
    },
    // 搜索重置
    searchReset() {
      this.unit = ''
      this.number = ''
      this.type = ''
      this.grainBelong = ''
      this.grainKind = []
      this.timepicker = ''
    },
    // 新增和详情和编辑按键
    buttonSwitch(id, state,qid) {
      this.setQualityId(id);
      this.setQualityState(state);
      this.setQuaid(qid)
      this.$emit('update:comName', 'ReportAdd')
    },
    // 删除方法
    deleteData(id) {
      httpToken({
        method: 'post',
        url: '/granary-quality-report/del',
        data: qs.stringify({ ids: id, })
      }).then(res => {
        console.log(res)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getDataList(this.currentPage, 'delete')
      })
    },
    // 删除按键
    deleteButton(val) {
      console.log(val)
      this.$confirm('是否确认删除这条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteData(val)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 导出
    exportExcel() {
      if(this.exportloading){
        return
      }
      this.exportData=[]
      this.exportloading=true
      httpToken({
        method: "post",
        url: '/granary-quality-report/all',
        data: qs.stringify({
          paramData: JSON.stringify(this.getparamData()),
        }),
      }).then((res) => {
        if(res.data.data){
          this.exportData = res.data.data
        }
        if (this.exportData && this.exportData.length > 0) {
          export2Excel(this.columns, this.exportData, "质检报告");
        } else {
          this.$message({
            message: '导出数据暂无',
            type: 'info'
          })
        }
        this.exportloading=false
      }).catch(()=>{
        this.exportloading=false
      })
    },
    // 显示弹窗
    alertShow(str, val, width) {
      console.log(str, val);
      this.showid = str;
      this.showwidth = width;
      this.showdata = val;
      this.showalert = true;
    },
    // 分页器
    handleCurrentChange(val) {
      this.getDataList(val)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getDataList(this.currentPage);
    },
    // 获取粮权所属的下拉选项
    getGrainBelongOptions() {
      httpToken({
        url: '/grain-owned/all',
        method: 'post'
      }).then(res => {
        // console.log(res.data.data)
        const belongList = res.data.data
        this.grainBelongList = [{
          value: null,
          label: '全部'
        }]
        for (let j = 0; j < belongList.length; j++) {
          this.grainBelongList.push(
            {
              value: belongList[j].companyName,
              label: belongList[j].companyName
            })
        }
      })
    }
  },
};
</script>
<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.showbodymax {
  width: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN, serif;
  font-weight: 400;
  color: #969696;

  .title {
    margin-bottom: 24px;
  }
}

.table_title {
  display: flex;
  margin-bottom: 20px;

  .table_title_left {}

  .table_title_right {
    margin-left: auto;
  }
}

.showbody_padding {
  padding: 30px 0;
}

.showbody_bor {
  border-top: 1px solid #eeeeee;
}

.showbody {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: Source Han Sans CN, serif;
  font-weight: 400;
  color: #969696;

  .inputbox_marginr {
    margin-right: 5%;
  }

  .inputbox {
    width: 30%;
    margin-bottom: 14px;

    .title {
      font-size: 14px;
      font-family: Source Han Sans CN, serif;
      font-weight: 400;
      color: #969696;
      margin-bottom: 14px;
    }

    .input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      overflow: auto;
      white-space: nowrap;
      box-sizing: border-box;
      padding-left: 10px;
      background: #f4f7fd;
      border: 1px solid #dcdcdc;
    }

    .input::-webkit-scrollbar {
      display: none;
    }
  }
}

.searchlistbox {
  width: 100% !important;
  padding-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #376bf4;
  display: flex;
  flex-wrap: wrap;

  .content_head_seek {
    margin-left: 20px;
    margin-bottom: 20px;
    // width: 25%;
  }
}

.content_head {
  width: 100%;
  display: flex;
  font-size: 18px;
  margin-bottom: 10px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    padding-top: 4px;
    margin-right: 10px;

    // margin: auto 10px auto 0;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    white-space: nowrap;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1b1b1b;
  }

  .content_head_button {
    flex: auto;
    max-width: 1050px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    .content_searchlistbox {
      position: relative;

      .content_searchlist {
        position: absolute;
        top: 40px;
        left: calc(50% - 9px);
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      margin-bottom: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }
    }
  }
}

.Notice_alert {
  ::v-deep .el-table th {
    background-color: #f4f7fd;
  }

  ::v-deep .el-table thead {
    color: #969696;
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #f5f8ff;
  }

  ::v-deep .el-table thead {
    color: #000000;
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
